// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__eOqUE","sendOtp":"AuthorizeToLogin_sendOtp__mZsU5"};